import * as RadixAvatar from "@radix-ui/react-avatar";
import React from 'react';
import { IUser } from "@/integration/user/interfaces/IUser.ts";
import { Link } from "react-router-dom";

interface AvatarProps {
  children?: React.ReactNode;
  src?: string;
  alt?: string;
  statusColor?: string;
  user?: IUser | null;
  link?: string;
  sizeClass?: string; // Classe do Tailwind para definir o tamanho
  showStatus?: boolean;
  showPopover?: boolean;
  defaultImage?: string;
  className?: string; // Permite adicionar classes CSS personalizadas
}

const Avatar: React.FC<AvatarProps> = ({
  children,
  src,
  alt,
  link,
  user,
  sizeClass = "w-12 h-12",
  defaultImage,
  className,
}) => {
  const avatarImage = src || user?.picture || defaultImage;
  const avatarAlt = alt || user?.name || "Avatar";

  const avatarContent = (
    <>
      {avatarImage ? (
        <RadixAvatar.Image
          className="rounded-full w-full h-full object-cover"
          src={avatarImage}
          alt={avatarAlt}
        />
      ) : (
        <RadixAvatar.Fallback className="flex items-center justify-center w-full h-full text-white">
          {children || "?"}
        </RadixAvatar.Fallback>
      )}
    </>
  );

  return (
    <div className={`flex ${className}`}>
      <RadixAvatar.Root
        className={`relative ${className} bg-gray-800 rounded-full border-2 border-gray-700/50 flex items-center justify-center overflow-hidden ${sizeClass}`} // Aplica a classe de tamanho do Tailwind
      >
        {link ? <Link to={link}>{avatarContent}</Link> : avatarContent}
      </RadixAvatar.Root>
    </div>
  );
};

export default Avatar;
